import { twMerge } from 'tailwind-merge';

import { IMediaItem } from 'routes/media/models/i-media-item.interface';

import styles from './MediaItem.module.scss';

const MediaItem = ({ item, isVideo }: IMediaItem) => {
  const { url, thumb, logoUrl, name, description } = item;

  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      className="tw-block tw-w-[calc(320px+2.5rem)] tw-max-w-full lg:tw-w-[calc(400px+2.5rem)]"
    >
      <div
        className={twMerge(
          'tw-relative tw-mx-2.5 tw-mb-5 tw-block tw-max-w-full tw-overflow-hidden tw-rounded-2xl tw-bg-clip-padding sm:tw-mx-5 sm:tw-mb-[7.5]',
          styles['gradient-border'],
          isVideo && styles['play-button']
        )}
      >
        <img className="tw-max-w-full tw-rounded-2xl" src={thumb} alt="" />
      </div>
      <div className="tw-mx-2.5 tw-mt-2 tw-flex tw-max-w-full">
        {logoUrl && <img className="tw-h-[54px] tw-w-[54px] tw-rounded-[5px] tw-object-fill" src={logoUrl} alt="" />}
        <div className="tw-w-[calc(100%-54px-0.875rem)] tw-pl-3.5">
          <p className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-xl tw-text-white sm:tw-text-2xl">
            {name}
          </p>
          <p className="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-base tw-text-skyBlue sm:tw-text-lg">
            {description}
          </p>
        </div>
      </div>
    </a>
  );
};

export default MediaItem;
